<template>
    <div class="footer">
        <div class="newsletter">
            <div class="news">
                <p>Alamat</p>
                Perumahan Bumi Mondoroko Blok GN ll Nomor 40, DesKekrahan
                Watugede, Koc, Singosar, Keb, Malang, Provinsi Jawa Tirmur.
                Kode Pos: 65153
            </div>
            <div class="email-text">
                <div class="email-box">
                    <input type="text" placeholder="Masukkan email Anda" v-model="m_value_1" class="input-box">
                    <div class="input-btn" @click="Submit">Kirim</div>
                </div>
                <p>claire@mettabhavanatunggal.com</p>
            </div>
        </div>
        <div class="relume-box">
            <div class="logo-box">
                <img src="../assets/logo-2.png" alt="">
                PT METTA BHAVANA TUNGGAL
            </div>
            <div class="rights">© 2024 Relume. All rights reserved.</div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'Footer',
    data() {
        return {
            m_value_1: ''
        }
    },
    mounted() {

    },
    methods: {
        Submit() {
            if (!this.m_value_1) {
                return alert('Masukkan email Anda')
            }
            alert('Sudah terkirim')
        }
    }
}
</script>

<style lang="less" scoped>
.footer {
    padding: 80px 300px;
    background: #3B3B3B;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;

    .newsletter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 80px;

        .news {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            width: 600px;

            p {
                font-weight: 600;
                font-size: 18px;
            }
        }

        .email-text {
            font-weight: 400;
            font-size: 12px;

            p {
                margin-top: 20px;
            }

            .email-box {
                display: flex;
                align-items: center;
                justify-content: center;

                .input-box {
                    width: 200px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 80px 80px 80px 80px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #505050;
                    padding: 0px 25px;
                    margin-right: 20px;
                }

                .input-btn {
                    width: 131px;
                    height: 52px;
                    background: #FFFFFF;
                    border-radius: 80px 80px 80px 80px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #505050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }
        }

    }

    .relume-box {
        border-top: 1px solid #FFFFFF;
        padding-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo-box {
            font-weight: 400;
            font-size: 36px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                height: 50px;
                margin-right: 20px;
            }
        }

        .rights {
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
        }
    }

}
</style>